module.exports = __webpack_public_path__ + "images/defaultAvatar.5dfb1249302d6d9432120cb6480352dd.jpg";